import { __rest, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import KModal from '../../KModal/index.js';

var DownloadManagerModal = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.footer, footer = _b === void 0 ? null : _b, id = _a.id, _c = _a.testId, testId = _c === void 0 ? "downloadManagerModal" : _c, rest = __rest(_a, ["children", "className", "footer", "id", "testId"]);
    return (React__default.createElement(KModal, __assign({ testId: testId, id: id, className: clsx("DownloadManagerModal", className) }, rest),
        children,
        footer));
};

export { DownloadManagerModal as default };
//# sourceMappingURL=index.js.map
